define("ember-svg-jar/inlined/attachment", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = _exports.default = {
    "content": "<path d=\"M16.584 24.422Q14.073 27 10.547 27t-6.036-2.578T2 18.226t2.511-6.196l8.934-9.171Q15.255.999 17.79 1q2.535 0 4.346 1.859 1.81 1.86 1.81 4.461t-1.81 4.462l-8.45 8.675q-1.112 1.14-2.657 1.14t-2.656-1.14a3.77 3.77 0 01-1.11-2.727 3.77 3.77 0 011.11-2.726l8.934-9.17 1.931 1.982-8.933 9.17a1.034 1.034 0 000 1.488q.314.322.724.322a.98.98 0 00.725-.322l8.45-8.675q.99-1.065 1.002-2.491.012-1.425-1.002-2.466T17.791 3.8t-2.415 1.04l-8.933 9.171q-1.74 1.735-1.727 4.201.012 2.467 1.727 4.226 1.69 1.735 4.068 1.723 2.379-.012 4.14-1.723l9.417-9.666L26 14.756z\"/>",
    "attrs": {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "28",
      "height": "28",
      "fill": "currentColor",
      "viewBox": "0 0 28 28"
    }
  };
});